var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "30dlth43ua",
    d: "M10.893 0c1.108 0 2.024.825 2.102 1.9l.005.148v6.904c0 1.077-.867 1.967-1.957 2.043l-.15.005H8V9h2.893c.05 0 .085-.022.1-.037L11 8.952V2.048c0-.014-.017-.034-.058-.043L10.893 2H2.107c-.05 0-.085.022-.1.037L2 2.048V3H0v-.952C0 .971.867.081 1.957.005L2.107 0h8.786zm9.102 1.4L20 1.53v7.925c0 .282-.073.538-.194.769-.389.7-1.186.968-1.866.634l-.126-.07L14 8.48v-5.95L17.79.221c.12-.077.267-.154.412-.18.905-.22 1.72.471 1.793 1.36zM18 2.435l-2 1.219v3.698l2 1.21V2.434z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "foonhuw09c",
    d: "M6 10v3.999L10 14v2l-4-.001V20H4v-4.001L0 16v-2l4-.001V10h2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1396.000000, -124.000000) translate(1388.000000, 116.000000) translate(8.000000, 8.000000) translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3zi15o29eb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#30dlth43ua"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#090C10",
    fillRule: "nonzero",
    mask: "url(#3zi15o29eb)",
    className: "icon-record-camera"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-4.000000, -5.000000)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1396.000000, -124.000000) translate(1388.000000, 116.000000) translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p4jmr0zohd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#foonhuw09c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CB0000",
    mask: "url(#p4jmr0zohd)",
    className: "icon-record-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecord);
export default __webpack_public_path__ + "static/media/icon-record.a11bbd51d91d49a7340b36c726cff182.svg";
export { ForwardRef as ReactComponent };